import { render } from "./PartnersDetail.vue?vue&type=template&id=535ae3eb&scoped=true"
import script from "./PartnersDetail.vue?vue&type=script&lang=js"
export * from "./PartnersDetail.vue?vue&type=script&lang=js"

import "./PartnersDetail.vue?vue&type=style&index=0&id=535ae3eb&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535ae3eb"]])

export default __exports__